import controller from './academy-course-container.controller';
import template from './academy-course-container.component.html';

const academyCourseContainer = {
  bindings: {
    courseTrack: '<',
    user: '<',
    useRedesign: '<',
    useRedesignCatalog: '<',
  },
  template,
  controller,
};

export default academyCourseContainer;
